import axios from "axios";
import toast from "react-hot-toast";

const http = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL || "https://www.staging.move9ja.com/api/v1/",
});

http.interceptors.request.use(
  async (req) => {
    req.headers.Authorization = localStorage.getItem("token") ?? "";
    return req;
  },
  async (error) => {
    Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
http.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem("token");
      window.location.href = "/";
      return Promise.reject(error);
    }
    
    // Handle 400 Bad Request with token expiration message
    if (error.response?.status === 400 && 
        error.response?.data?.success === false && 
        (error.response?.data?.message === "Invalid token Or Expired Token" || 
         error.response?.data?.data?.err?.name === "TokenExpiredError")) {
      // Clear token and redirect to login
      localStorage.removeItem("token");
      window.location.href = "/";
      return Promise.reject(error);
    }
    
    // Handle 429 Too Many Requests — surface a clear message, no local retry
    // (React Query's global `retry` config already governs retry behavior).
    if (error.response?.status === 429) {
      const retryAfterHeader = error.response?.headers?.["retry-after"];
      const retryAfterSeconds = retryAfterHeader
        ? Number(retryAfterHeader)
        : undefined;
      const waitMsg =
        retryAfterSeconds && !Number.isNaN(retryAfterSeconds)
          ? ` Please try again in ${retryAfterSeconds}s.`
          : " Please wait a moment and try again.";
      toast.error(
        (error.response?.data?.message || "Too many requests.") + waitMsg,
        { id: "rate-limit-429" } // dedupe: avoid stacking identical toasts on repeat 429s
      );
    }

    return Promise.reject(error);
  }
);

export default http;
